<template>
  <div>
    <Progress progress="6"></Progress>
    <div class="contain">
       <div class="card" @click="handNext(1)">
         <img src="../../../assets/images/open-account/china.png" alt="" class="logo">
         <div class="middle">
           <div class="title">{{ $t('ChooseIdentity.lang')}}</div>
           <div class="tip">{{ $t('ChooseIdentity.lang0')}}</div>
         </div>
         <div class="icon">
           <van-icon name="arrow" size="20" :color="bgColor == 'black-theme' ? '#FFFFFF':'#333333'" />
         </div>
       </div> 
      <div class="card1" @click="showLocalIdDialog = true">
        <img src="../../../assets/images/open-account/other-contury.png" alt="" class="logo">
        <div class="middle">
          <div class="title">{{ $t('ChooseIdentity.lang1')}}</div>
          <div class="tip">{{ $t('ChooseIdentity.lang2')}}、{{ $t('ChooseIdentity.lang3')}}</div>
        </div>
        <div class="icon">
          <van-icon name="arrow" size="20" :color="bgColor == 'black-theme' ? '#FFFFFF':'#333333'" />
        </div>
      </div>

    </div>

    <van-popup v-model="showLocalIdDialog" class="local-id-popup" round>
      <div class="local-id-main">
        <p class="tip">{{ $t('ChooseIdentity.localIdDialog_tip') }}</p>
        <p class="message">{{ $t('ChooseIdentity.localIdDialog_message') }}</p>
        <div class="btn-box">
          <div class="btn" @click="onLocalIdAnswer(false)">{{ $t('ChooseIdentity.localIdDialog_no') }}</div>
          <div class="btn" @click="onLocalIdAnswer(true)">{{ $t('ChooseIdentity.localIdDialog_yes') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Progress from "../components/Progress.vue";
import { Icon, Toast, Popup } from "vant";
import { getBrowser } from "@/utils/browser";
import { setStatementDetailInfo } from "@/utils/hybirdMethods";
export default {
     components:{
       Progress,
       // eslint-disable-next-line vue/no-unused-components
       VanIcon:Icon,
       [Popup.name]: Popup
     },
     data(){
       return {
         showLocalIdDialog: false
       }
     },
     computed:{
       bgColor() {
         return this.$store.getters["common/bgColor"];
       }
     },
    created() {
      if(getBrowser().isApp){
        setStatementDetailInfo({
          headerTitle: this.$route.meta.title,
          hideTitle: '0'
        })
      }
    },
    methods:{

       onLocalIdAnswer(hasLocalId) {
         this.showLocalIdDialog = false
         this.handNext(3, { has_local_id: hasLocalId ? 1 : 0 })
       },
      handNext(id, extraConfig = {}){
        const toastLoading = Toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: "spinner",
          message: this.$t("common.loading_text")
        });
        // 如果选择了中国内地就要把步骤1的process_id重置下
        const step1Promise = id === 1
          ? this.$apis.supplementSaveApi({ step_code: 1, step_order: 1, process_id: 1, config_data: {} })
          : Promise.resolve(true)
          
        // 下面正常提交2-2
        const params = {
          step_code:'2-2',
          step_order:2,
          process_id:id,
          config_data:{
            process_id:id,
            ...extraConfig
          }
        }
        step1Promise.then(() => {
          return this.$apis.supplementSaveApi(params)
        }).then(res => {
          if(res){
            this.$router.push({
             //  path:'/open-account/id-card-upload'
              path:'/open-account/openReference'
            }).finally(() =>{
              toastLoading.clear()
            })
          }
        }).catch(() =>{

        })
      }
     }
   }



</script>

<style scoped lang="less">
   .contain{
     margin-top: 40px;
     text-align: left;
     .card{
       display: flex;
       background: #F6F7FA;
       width: 92%;
       border-radius: 24px;
       margin: 0 auto;
       margin-top: 122px;
       height: 200px;
       .logo{
         width: 88px;
         height: 88px;
         margin-top: 56px;
         margin-left: 32px;
       }
       .middle{
         margin-top: 56px;
         margin-left: 16px;
         .title{
           color: #17161c;
           font-size: 32px;
           font-weight: 600;
         }
         .tip{
           font-size: 28px;
           color: #747377;
           font-weight: 400;
           margin-top: 7px;
         }
       }
       .icon{
         flex: 1;
         text-align: right;
         margin-top: 82px;
         padding-right: 20px;
       }
     }
     .card1{
       display: flex;
       background: #F6F7FA;
       width: 92%;
       border-radius: 24px;
       margin: 24px auto;
       height: 200px;
       .logo{
         width: 88px;
         height: 88px;
         margin-top: 56px;
         margin-left: 32px;
       }
       .middle{
         margin-top: 56px;
         margin-left: 16px;
         .title{
           color: #17161c;
           font-size: 32px;
           font-weight: 600;
         }
         .tip{
           font-size: 28px;
           color: #747377;
           font-weight: 400;
           margin-top: 7px;
         }
       }
       .icon{
         flex: 1;
         text-align: right;
         margin-top: 82px;
         padding-right: 20px;
       }
     }
   }
   .local-id-popup {
     width: 600px;
     border-radius: 32px;
     .local-id-main {
       padding: 45px;
       text-align: center;
       .tip {
         font-size: 36px;
         font-weight: 500;
         color: #17161c;
       }
       .message {
         margin-top: 32px;
         font-size: 32px;
         color: #747377;
       }
       .btn-box {
         display: flex;
         margin-top: 40px;
         .btn {
           flex: 1;
           height: 104px;
           line-height: 104px;
           border-radius: 104px;
           font-size: 28px;
           font-weight: 500;
           color: #17161c;
           background: rgba(15, 15, 47, 0.04);
           & ~ .btn {
             margin-left: 20px;
             color: #fff;
             background: #17161c;
           }
         }
       }
     }
   }
   .black-theme{
     .contain{
       .card{
         background: #0A0B0F;
         .middle{
           .title{
             color: #F9FAFC;
           }
           .tip{
             color: #9D9D9F;
           }
         }
       }
       .card1{
         background: #0A0B0F;
         .middle{
           .title{
             color: #F9FAFC;
           }
           .tip{
             color: #9D9D9F;
           }
         }
       }
     }
     .local-id-popup {
       background: #262830;
       .local-id-main {
         .tip {
           color: #fff;
         }
         .message {
           color: #9D9D9F;
         }
         .btn-box {
           .btn {
             color: #fff;
             background: rgba(255, 255, 255, 0.1);
             & ~ .btn {
               background: #377CFB;
             }
           }
         }
       }
     }
   }
</style>
